import type { PopupBrandColor } from '@onetext/api';

export const brandColors : PopupBrandColor = {
    text:       '#ffffff',
    background: 'rgba(25,25,25,0.9)'
};
